export { default as BaseDateInput } from "./Base-Date-Input.vue";

export { default as BaseInputCheckbox } from "./Base-Input-Checkbox.vue";

export { default as BaseInputNumeric } from "./Base-Input-Numeric.vue";

export { default as BaseInputString } from "./Base-Input-String.vue";

export { default as BaseRemoteSelect } from "./Base-Remote-Select.vue";

export { default as BaseSelectBox } from "./Base-Select-Box.vue";

export { default as BaseTextArea } from "./Base-Text-Area.vue";

export { default as BaseWrapper } from "./Base-Wrapper.vue"

export { default as Blable } from "./Blabel.vue"

export default function (Vue) {
    // https://webpack.js.org/guides/dependency-management/#require-context
    const requireComponent = require.context(
        // Look for files in the src/components directory
        './',
        // Do not look in subdirectories
        false,
        // Only include "Base" prefixed .vue files
        /Base-[\w-]+\.vue$/
    )
    // For each matching file name...
    requireComponent.keys().forEach((fileName) => {
        // Get the component config
        const componentConfig = requireComponent(fileName)
        // Get the PascalCase version of the component name
        const componentName = fileName
            // Remove the "./_" from the beginning
            .replace(/^\.\//, '')
            // Remove the file extension from the end
            .replace(/\.\w+$/, '')
            // Split up kebabs
            .split('-')
            // Upper case
            .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
            // Concatenated
            .join('')
        // Globally register the component
        Vue.component(componentName, componentConfig.default || componentConfig)
    });
}